import request from '@/utils/request'

export default {
  // 获取专升本分数线列表
  getList() {
    return request.get('/upgrade-score-line/list')
  },

  // 添加专升本分数线
  add(data) {
    return request.post('/upgrade-score-line/add', data)
  },

  // 更新专升本分数线
  update(data) {
    return request.put('/upgrade-score-line/update', data)
  },

  // 删除专升本分数线
  delete(id) {
    return request.delete(`/upgrade-score-line/delete/${id}`)
  },

  // 根据专业名称列表获取分数线（改用 POST 避免 URL 过长）
  getByMajors(majorNames) {
    // 将专业名称数组或逗号分隔的字符串转换为数组
    let majorNamesArray = majorNames
    if (typeof majorNames === 'string') {
      majorNamesArray = majorNames.split(',').filter(name => name.trim())
    }
    
    return request.post('/upgrade-score-line/by-majors', {
      majorNames: majorNamesArray
    })
  }
}
